import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { UtilityService } from 'src/app/services/utility.service';
import { WizardService } from 'src/app/services/wizard/wizard.service';
import { constants } from 'src/environments/constants';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-continue-button',
  templateUrl: './continue-button.component.html',
  styleUrls: ['./continue-button.component.scss']
})
export class ContinueButtonComponent implements OnInit {
  @Input() disableContinueButton: boolean = false;
  @Input() nextStepRoute: string = "";
  @Input() nextStepNumber: number = 1;
  @Input() isStartStep: boolean = false;
  @Input() currentStepName: string = "";
  @Input() totalSteps: number = 0;

  startButtonText: string = "";
  continueButtonText: string = "";
  ariaLabelBeginning: string = "";

  constructor(
    private analyticsService: AnalyticsService,
    private confSvc: ConfigService,
    private utilityService: UtilityService,
    private wizardService: WizardService,
    private router: Router) { }

  async ngOnInit(): Promise<void> {
    await this.confSvc.setup();

    this.startButtonText = this.confSvc.getString("startButtonText");
    this.continueButtonText = this.confSvc.getString("continueButtonText");
    this.ariaLabelBeginning = this.isStartStep ? "Start." : "Continue.";
  }

  continueBtnClickEvent(): void {
    this.analyticsService.logContinueBtnClick(this.currentStepName);

    this.wizardService.getStepRoutingQueryString().subscribe((queryString: string) => {
      this.router.navigateByUrl(`${this.nextStepRoute}${queryString}`);
    });
  }

  mobileStartBtnClickEvent(): void {
    this.analyticsService.logContinueBtnClick(this.currentStepName);
    const currentLocaleName = this.utilityService.getLocaleInfo().localeName;
    this.utilityService.openUrlInNewTab(`${environment.standaloneAppBaseUrl}primary-use?${constants.LOCALE_QUERY_PARAM}=${currentLocaleName}`);
  }
}
